import React from 'react';
import { Card as CardEl, theme } from '@veeqo/ui';
import { VeeqoInlineSubtitle } from '../../Subtitles/VeeqoInlineSubtitle';
import { Alert } from '../../Alert/Alert';
import { ContentType, ErrorType } from '../../../content';
import { Progress } from '../../Progress/Progress';

export const DefaultCard = ({
  error,
  ready,
  contentType,
}: {
  error?: ErrorType;
  ready?: boolean;
  contentType: ContentType;
}) => (
  <CardEl
    style={{
      marginTop: '7.75rem',
      marginBottom: '6.5rem',
      width: '50%',
      borderRadius: theme.sizes.xs,
      minHeight: '250px',
      maxWidth: '700px',
      minWidth: '500px',
    }}
  >
    <VeeqoInlineSubtitle contentType={contentType} />
    {!error && !ready && (
      <Progress contentType={contentType} loadingColor={theme.colors.secondary.blue.base} />
    )}
    {error && <Alert contentType={contentType} errorKey={error} />}
  </CardEl>
);
